module.exports = __webpack_public_path__ + "img/island-chicken-dinner.342a18a2.jpg";